import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';
import { buildAddressPayload } from '../utils/addressForm';

const isOkStatus = (status) => status >= 200 && status < 300;
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result || '');
    reader.onerror = () => reject(new Error('Neuspesno citanje fajla.'));
    reader.readAsDataURL(file);
  });

const normalizeComparableUserValue = (key, value) => {
  if (key === 'dateOfBirth') {
    return value ? String(value).slice(0, 10) : '';
  }

  if (key === 'consentImages') {
    return JSON.stringify(Array.isArray(value) ? value : []);
  }

  if (key === 'address') {
    return JSON.stringify(buildAddressPayload(value) || {});
  }

  if (key === 'contact') {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value?._id ? String(value._id) : '';
  }

  if (key === 'shouldBeContacted') {
    return typeof value === 'boolean' ? value : '';
  }

  return value || '';
};

export const fetchUserById = async (id) => {
  console.log('id 123', id);
  try {
    const response = await authClient.get(`/users/${id}`);
    console.log('response 123', response);

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik ucitan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const fetchUsers = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
  userSearch = null,
  lboSearch = null,
  bzkSearch = null,
  phoneSearch = null,
  userBirthdaySearch = null,
}) => {
  try {
    // view=table: bek vraca samo kolone tabele (bez kontakta, saglasnosti i
    // ostalih detalja). Detalji/izmena dofetchuju korisnika po id-ju.
    let query = `?page=${page}&limit=${limit}&view=table`;

    Object.entries(filter).forEach(([key, value]) => {
      if (!value || value === 'all') return;

      if (Array.isArray(value)) {
        query += `&${key}=${value.map((v) => encodeURIComponent(v)).join(',')}`;
      } else {
        query += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }
    if (userSearch) {
      query += `&userSearch=${encodeURIComponent(userSearch)}`;
    }
    if (lboSearch) {
      query += `&lboSearch=${encodeURIComponent(lboSearch)}`;
    }
    if (bzkSearch) {
      query += `&bzkSearch=${encodeURIComponent(bzkSearch)}`;
    }
    if (phoneSearch) {
      query += `&phoneSearch=${encodeURIComponent(phoneSearch)}`;
    }
    if (userBirthdaySearch) {
      query += `&userBirthdaySearch=${encodeURIComponent(userBirthdaySearch)}`;
    }

    const response = await authClient.get(`/users${query}`);

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const fetchUserActivityLogs = async ({
  page = 1,
  limit = 10,
  userId = null,
  lbo = null,
  eventType = [],
  from = null,
  to = null,
}) => {
  try {
    const params = new URLSearchParams();

    params.set('page', String(page));
    params.set('limit', String(limit));

    if (userId) {
      params.set('userId', userId);
    }
    if (lbo) {
      params.set('lbo', lbo);
    }
    if (Array.isArray(eventType) && eventType.length > 0) {
      params.set('eventType', eventType.join(','));
    } else if (eventType) {
      params.set('eventType', eventType);
    }
    if (from) {
      params.set('from', from);
    }
    if (to) {
      params.set('to', to);
    }

    const response = await authClient.get(
      `/users/activity-logs?${params.toString()}`
    );

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisničkih izmena.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const fetchUserCount = async () => {
  try {
    const response = await authClient.get(`/users-count`);
    return {
      data: response.data?.count ?? null,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Broj korisnika ucitan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju broja korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const deleteUser = async (id, password) => {
  try {
    const response = await authClient.delete(`/users/${id}`, {
      data: { password },
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik trajno deaktiviran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri brisanju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

// Trajno (nepovratno) brisanje pacijenta i svega vezanog za njega - za razliku od
// deleteUser, koji samo postavlja status "deleted". Samo admin, uz njegovu lozinku.
// `code` (npr. USER_PASSWORD_INVALID, USER_NOT_FOUND) vraca se da pozivalac moze
// da odluci kako da reaguje; `message` je vec preveden na beku.
export const permanentlyDeleteUser = async (id, password) => {
  try {
    const response = await authClient.delete(`/users/${id}/permanent`, {
      data: { password },
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Pacijent je trajno obrisan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri trajnom brisanju pacijenta.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
      code: error?.response?.data?.code || null,
    };
  }
};

export const verifyUser = async (
  id,
  isDocumentVerified,
  reasonForRejection = ''
) => {
  try {
    const response = await authClient.patch(`/user-account/verify/${id}`, {
      documentVerified: isDocumentVerified,
      reasonForRejection: reasonForRejection,
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik verifikovan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri verifikaciji korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const changeVerificationStatus = async (id, isVerified, type) => {
  const status = isVerified === true ? 'active' : isVerified === false;

  try {
    const response = await authClient.patch(`/user/${id}`, {
      status,
      documentVerified: isVerified,
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Status uspesno azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri arhiviranju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};
export const activeUser = async (id) => {
  try {
    const response = await authClient.post(`/activate-user/${id}`);

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik aktiviran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greske pri aktiviranju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const blockUser = async (id) => {
  try {
    const response = await authClient.post(`/block-user/${id}`);

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik arhiviran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri blokiranju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const bulkUpdateUserStatus = async ({ ids, status }) => {
  try {
    const response = await authClient.put('/users/bulk-status', {
      ids,
      status,
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Statusi korisnika azurirani.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri masovnom azuriranju statusa korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const importUsersFromExcel = async (file) => {
  try {
    const fileBase64 = await toBase64(file);
    const response = await authClient.post('/users/import', {
      fileBase64,
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Pacijenti importovani.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri importu pacijenata.'
    );
    return {
      data: error?.response?.data || null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateUser = async (id, formData, user) => {
  try {
    const updatedFields = {};
    Object.keys(formData).forEach((key) => {
      const comparableNextValue = normalizeComparableUserValue(
        key,
        formData[key]
      );
      const comparableCurrentValue = normalizeComparableUserValue(
        key,
        key === 'consentImages' ? user?.consentImageIds : user?.[key]
      );

      if (
        key === 'password'
          ? formData.password &&
            formData.password !== (user?.passwordToken || '')
          : comparableNextValue !== comparableCurrentValue
      ) {
        updatedFields[key] =
          key === 'address'
            ? buildAddressPayload(formData[key]) || {}
            : formData[key];
      }
    });

    const response = await authClient.put(`/update-user/${id}`, updatedFields);

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik uspesno azuriran.',
      code: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
      code: error?.response?.data?.code || error?.response?.data?.error || null,
    };
  }
};

export const updateUserPassword = async (id, password) => {
  try {
    const response = await authClient.put(`/update-user/${id}`, { password });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Lozinka korisnika uspesno azurirana.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju lozinke korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateOwnAccount = async (formData, user) => {
  try {
    const updatedFields = {};

    Object.keys(formData).forEach((key) => {
      if (key === 'lbo') {
        return;
      }

      if (key === 'healthBookletNumber') {
        return;
      }

      if (
        key === 'password'
          ? formData.password &&
            formData.password !== (user?.passwordToken || '')
          : JSON.stringify(formData[key]) !== JSON.stringify(user?.[key])
      ) {
        updatedFields[key] = formData[key];
      }
    });

    const response = await authClient.patch(
      `/user-account/${user._id}`,
      updatedFields
    );

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Nalog je uspesno azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju naloga.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};

export const createUser = async (userData) => {
  try {
    let route = '/users';
    const response = await authClient.post(route, userData);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Korisnik kreiran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri kreaciji novog korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};
